import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';


export interface ProductUpsertState extends ApiState {
  productId?: string
}

export default requestReducer<ProductUpsertState>('PRODUCT_UPSERT')
